var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 4V13C17.75 14.08 17.13 15.01 16.23 15.46C16.24 15.31 16.25 15.16 16.25 15V6C16.25 3.66 14.34 1.75 12 1.75H3.63C4.09 0.86 5.01 0.25 6.08 0.25H14C16.07 0.25 17.75 1.93 17.75 4ZM12 3.25H3C1.483 3.25 0.25 4.483 0.25 6V15C0.25 16.517 1.483 17.75 3 17.75H12C13.517 17.75 14.75 16.517 14.75 15V6C14.75 4.483 13.517 3.25 12 3.25Z",
    fill: "#FFB829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareCopy);
export default __webpack_public_path__ + "static/media/share-copy.e096717a6cc0f8d8b64c5a9a47eda6ed.svg";
export { ForwardRef as ReactComponent };